import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { Small } from '@finect/tabular-core/Small';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-2okg0s-0"
})(["position:relative;padding:18px 0 0;"]);
export var EntryBlock = styled.div.withConfig({
  displayName: "partials__EntryBlock",
  componentId: "sc-2okg0s-1"
})(["position:relative;padding:15px 30px 12px 24px;margin:12px 0;&:after{position:absolute;top:9px;bottom:9px;left:", "px;left:", "px;left:2.5px;border:2.5px solid ", ";border-radius:2.5px;content:'';background-color:", ";}"], 30 / 2 - 2.5, 48 / 2 - 2.5, function (_ref) {
  var theme = _ref.theme,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected;
  return selected ? theme.colors.positive : theme.mainColor;
}, function (_ref2) {
  var theme = _ref2.theme,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? false : _ref2$selected;
  return selected ? theme.colors.positive : theme.mainColor;
});
export var SelectedAnswerBadge = styled.div.withConfig({
  displayName: "partials__SelectedAnswerBadge",
  componentId: "sc-2okg0s-2"
})(["display:inline-flex;align-items:center;padding:5px 7px 5px 0;color:#fff;color:", ";", ";svg{width:16px;height:16px;margin-right:4px;vertical-align:bottom;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.positive;
}, getFont(0));
export var PublicationDate = styled(Small).withConfig({
  displayName: "partials__PublicationDate",
  componentId: "sc-2okg0s-3"
})(["display:block;position:relative;padding-top:9px;margin-bottom:6px;&:before{position:absolute;top:0;left:0;width:24px;height:1px;content:'';background-color:", ";}a{color:", ";&:hover{text-decoration:underline;}}svg{position:relative;top:3px;margin-right:3px;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.fontL;
});